// extracted by mini-css-extract-plugin
export default {"label":"label---Jb01P","required":"required---IeSEO","separator":"separator---E12TL","centerNote":"centerNote---Xm722"};